import { EmailConfirmDialog } from "./EmailConfirmDialogBox";

export default EmailConfirmDialog;
